/** Every value appearing more than once, in first-duplicate order, compared by `Set` identity. */
export const findDuplicates = <T>(items: readonly T[]): T[] => [
  ...new Set(items.filter((item, index) => items.indexOf(item) !== index)),
];
